//组件调用this.$store.mutations.test
var mutations = {// //增加的mutation 
  // test(state){
  // 	state.count++
  // },
};
export default mutations;